import i18n from 'i18n-literally'

export const SUBSTRATE_PREFERRED_DATATYPES = ['pore_ec', 'soil_moist', 'soil_temp']
Object.freeze(SUBSTRATE_PREFERRED_DATATYPES)
export const CLIMATE_PREFERRED_DATATYPES = ['rel_hum', 'air_temp', 'vpd']
Object.freeze(CLIMATE_PREFERRED_DATATYPES)

export const CATEGORY_CATALOG = {
  get CLIMATE() {
    return i18n`Climate`
  },
  get SUBSTRATE() {
    return i18n`Soil/Substrate`
  },
  get IRRIGATION() {
    return i18n`Irrigation`
  },
  get IRRIGATION_FLOW() {
    return i18n`Irrigation DFI`
  },
  PH: 'pH',
  get OTHER() {
    return i18n`Other`
  },
}

export const climatePattern = /ENVIRONMENT|CLIMATE/
export const irrigationPattern = /IRRIGATION/
export const substratePattern = /SOIL|SUBSTRATE/
